import { useParams } from "react-router-dom";
import FormAudit from "../../components/forms/FormAudit/FormAudit";
import Breadcrumbs from "../../components/layout/BreadCrumbs";
import PageLayout from "../../components/layout/PageLayout/PageLayout";
import {
  useFetchAuditQuery,
  useFetchAuditTypesQuery,
  useFetchRolesQuery,
  useFetchSitesQuery,
  useFetchUsersForFieldQuery,
} from "../../features/api/apiSlice";
import styles from "../PageAudit/PageAudit.module.scss";

const PageAuditEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const auditId = Number(id);

  const { data: auditData, isFetching } = useFetchAuditQuery(auditId, {
    skip: !auditId,
  });
  const { data: sitesData } = useFetchSitesQuery();
  const { data: auditTypesData } = useFetchAuditTypesQuery();
  const { data: usersData } = useFetchUsersForFieldQuery("");
  const { data: rolesData } = useFetchRolesQuery();

  return (
    <PageLayout pageContainerClassName={styles.root} isLoading={isFetching}>
      <Breadcrumbs
        pageName="audit"
        auditId={auditData?.id}
        auditName={auditData?.title}
      />
      {!isFetching && !!auditData && (
        <FormAudit
          isEditMode
          audit={auditData}
          sites={sitesData?.results}
          auditTypes={auditTypesData?.results}
          users={usersData}
          roles={rolesData?.results}
        />
      )}
    </PageLayout>
  );
};

export default PageAuditEdit;
